module.exports = "<div *ngIf='utils.authenticated'>\n  <div class='editor'>\n    <span\n        [innerHTML]='email'></span>\n  </div>\n  <button class='logout'\n      (click)=\"utils.logout()\">Log Out</button>\n</div>\n\n<div *ngIf='!utils.authenticated'>\n  <button (click)=\"utils.login()\">Log In</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/login-box/login-box.component.html
// module id = ../../../../../src/app/login-box/login-box.component.html
// module chunks = main